export default __webpack_public_path__ + "static/media/3.43258a6b.jpg";